import employee from "./endpoints/employee";
import department from "./endpoints/department";
import job_title from "./endpoints/job_title";
import others from "./endpoints/others";
import announcements from "./endpoints/announcements";
import holidays from "./endpoints/holidays";
import flexibility from "./endpoints/flexibility";
import auth from "./endpoints/auth";
import profile from "./endpoints/profile";
import leave from "./endpoints/leave";
import attendance from "./endpoints/attendance";
import roles from "./endpoints/roles";
import notifications from "./endpoints/notifications";
import approvals from "./endpoints/approvals";
import reports from "./endpoints/reports";
import statistics from "./endpoints/statistics";
import shifts from "./endpoints/shifts";
import projects from "./endpoints/projects";
import compnay_tree from "./endpoints/compnay_tree";
import bonuses_cuts from "./endpoints/bonuses_cuts";
import advance_payments from "./endpoints/advance_payments";
import salary from "./endpoints/salary";
import manage_salary from "./endpoints/manage_salary";
import settings from "./endpoints/settings";
import employee_ratings from "./endpoints/employee_ratings";
import suspension_overtime from "./endpoints/suspension-overtime";

const repositories = {
  employee,
  department,
  job_title,
  others,
  announcements,
  holidays,
  flexibility,
  auth,
  profile,
  leave,
  attendance,
  roles,
  notifications,
  approvals,
  reports,
  statistics,
  shifts,
  projects,
  compnay_tree,
  bonuses_cuts,
  advance_payments,
  salary,
  manage_salary,
  settings,
  employee_ratings,
  suspension_overtime,
};

export const factory = {
  get: (name) => repositories[name],
};
